import React from 'react'
import styled from 'styled-components'

const Btn = styled.button`
    display: flex;
    height: 30px;
    width: 30px;
    padding: 0;
    align-items: center;
    justify-content: center;

    font-size: 0;

    background: var(--light-gray2);
    border: 0;
    border-radius: 50%;
    color: #333;
    cursor: pointer;
    outline: 0;
    -webkit-appearance: none;
    box-shadow: none;
    -webkit-box-shadow: none;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    svg {
        height: 15px;
        width: 15px;
    }
    &:hover {
        background: var(--light-gray3);
    }
`;
const CloseWrapper = styled.div`
    display: flex;
    height: 88px;
    width: 88px;
    margin-left: auto;
    align-items: center;
    justify-content: center;
`;

function CloseBtn(props) {

    function handleClose(event) {
        if(props.onClick) props.onClick()
    }
    return (
        <>
            <CloseWrapper>
                <Btn title="Close (Esc)" type="button" onClick={() => handleClose()}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                        <path fill="#242424" d="M26.363961,12.2218254 L27.7781746,13.636039 L21.4138254,19.9998254 L27.7781746,26.363961 L26.363961,27.7781746 L19.9998254,21.4138254 L13.636039,27.7781746 L12.2218254,26.363961 L18.5858254,19.9998254 L12.2218254,13.636039 L13.636039,12.2218254 L19.9998254,18.5858254 L26.363961,12.2218254 Z" transform="translate(-12 -12)"/>
                    </svg>
                </Btn>
            </CloseWrapper>
        </>
    );
}
export default CloseBtn;